module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-pdf-report-text"
    }
  }, [_vm._v("\n\tpdf report text\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6418c68a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoPdfReportText.vue
// module id = 3822
// module chunks = 1